'use client';

import type { ReactNode } from 'react';
import EditorialFooter from './EditorialFooter';
import EditorialHeader from './EditorialHeader';

export type PublicEditorialVariant = 'directorio' | 'jams' | 'escuelas' | 'salas';

interface PublicEditorialChromeProps {
  children: ReactNode;
  variant: PublicEditorialVariant;
  actionLabel: string;
  onAction: () => void;
  showLocalNavigation?: boolean;
}

export default function PublicEditorialChrome({
  children,
  variant,
  actionLabel,
  onAction,
  showLocalNavigation = false,
}: PublicEditorialChromeProps) {
  return (
    <>
      <EditorialHeader
        variant={variant}
        ctaLabel={actionLabel}
        onCtaClick={onAction}
        showLocalNavigation={showLocalNavigation}
      />
      {children}
      <EditorialFooter variant={variant} actionLabel={actionLabel} onAction={onAction} />
    </>
  );
}
